import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteToken } from '../../services/tokenservice';

const LogoutButton: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        deleteToken();
        navigate('/login');
    };

    return (
        <Button
            onClick={handleLogout}
            variant="contained"
            color="error"
            sx={{
                position: 'fixed',
                bottom: '24px',
                right: '24px',
            }}
        >
            Wyloguj
        </Button>
    );
};

export default LogoutButton;
